import { Outlet } from "react-router-dom";
import { MobileBottomNav } from "../components/MobileBottomNav";
import "../mobile.css";

/**
 * モバイル版全体レイアウト
 * 最大幅 430px、中央寄せ、白背景、底部ナビ固定
 * AppBar は各ページ側で <MobileHeader> を render する（タイトルが変わるため）
 */
export const MobileLayout = () => {
  return (
    <div className="mobile-shell">
      <Outlet />
      <MobileBottomNav />
    </div>
  );
};
